import { useEffect, useState } from 'react';
import { client } from '../api/client';

export const useTourOperatorMeta = () => {
    const [operatorMeta, setOperatorMeta] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOperatorMeta = async () => {
            try {
                setIsLoading(true);
                const host = window.location.host;
                const res = await client.get(`/edit/login/?host=${host}`);
                
                if (res.status === 200 && res.data) {
                    setOperatorMeta({
                        name: res.data.name,
                        logo: res.data.logo,
                        code: res.data.code
                    });
                } else {
                    setError('Failed to fetch operator metadata');
                }
            } catch (err) {
                console.error('Failed to fetch tour operator metadata:', err);
                setError(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchOperatorMeta();
    }, []);

    return { operatorMeta, isLoading, error };
};

